export default "__VITE_ASSET__BVqrdcUZ__"